
export const preloadedValues = {
  alleRecStatus:false,
  alIeOrigemUfdeId:"",
  alIeDestinoUfdeId:"",
  alIeicmsAliquota:"",
  alIeICMSAliquotaImportados:"",
  };